export {default as voronoi} from "./src/voronoi";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-voronoi/index.js
// module id = 951
// module chunks = 0